// Helper to get migration settings based on stage count and context kind
export function getMigrationFlagSettings(
  stageCount?: 2 | 4 | 6,
  contextKind?: string,
): { stageCount: number; contextKind?: string } | undefined {
  if (!stageCount) {
    return undefined;
  }

  const isSixStageMigration = stageCount === 6;
  const isTwoOrFourStageMigration = stageCount === 2 || stageCount === 4;

  if (isSixStageMigration && contextKind) {
    return { stageCount, contextKind };
  }

  if (isTwoOrFourStageMigration) {
    return { stageCount };
  }

  return undefined;
}
